import { render } from "./ProgramsTable.vue?vue&type=template&id=ce5cee88"
import script from "./ProgramsTable.vue?vue&type=script&lang=js"
export * from "./ProgramsTable.vue?vue&type=script&lang=js"

import "./ProgramsTable.vue?vue&type=style&index=0&id=ce5cee88&lang=css"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__